(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-say"] && !Shopify.designMode) return;
  try {
    
  function initCustomerSwiper() {
    const swiperElement = document.querySelector('.customerSwiper');

    if (!swiperElement) return;

    if (swiperElement.swiper) {
      swiperElement.swiper.destroy(true, true);
    }

    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,

      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },

      observer: true,
      observeParents: true,
      watchOverflow: true,
    });
  }

  /* first page load */
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initCustomerSwiper, 100);
  });

  /* after images load */
  window.addEventListener('load', function () {
    setTimeout(initCustomerSwiper, 100);
  });

  /* Shopify theme editor + dynamic section load */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initCustomerSwiper, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", initSwiper);
document.addEventListener("shopify:section:load", initSwiper);

window.openMediaPreview = function(type, src){

  const modal = document.querySelector(".media-preview-modal")
  const body = document.querySelector(".media-preview-body")

  body.innerHTML = ""

  if(type === "video"){
    body.innerHTML = `
      <video controls autoplay playsinline>
        <source src="${src}" type="video/mp4">
      </video>
    `
  } else {
    body.innerHTML = `
      <img src="${src}" alt="preview">
    `
  }

  modal.style.display = "flex"
}
document.querySelector(".media-close").onclick = function(){
  document.querySelector(".media-preview-modal").style.display="none"
  document.querySelector(".media-preview-body").innerHTML=""
}

window.onclick = function(e){
  const modal = document.querySelector(".media-preview-modal")
  if(e.target === modal){
    modal.style.display="none"
    document.querySelector(".media-preview-body").innerHTML=""
  }
}

function initSwiper() {
  // Wait until Swiper library is loaded
  if (typeof Swiper === "undefined") {
    setTimeout(initSwiper, 50);
    return;
  }

  // Destroy previous Swiper instance
  if (window.mySwiper) {
    window.mySwiper.destroy(true, true);
  }

  window.mySwiper = new Swiper(".mySwiper", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    loop: true,

    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      640: { slidesPerView: 2.2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 6 },
    },

    observer: true,
    observeParents: true,
  });

  // Update once images & page fully loaded
  window.addEventListener("load", () => {
    setTimeout(() => {
      if (window.mySwiper) window.mySwiper.update();
    }, 200);
  });
}



  } catch(e) { console.error(e); }
})();
})();
